import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { addCriticalCareItem } from '../../timeline/store/timeline.actions'
import { CriticalCareConstants } from '../../procedures/criticalCare/store/criticalCare.constants'
import { resetState } from '../../procedures/criticalCare/store/criticalCare.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveCriticalCareQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addCriticalCareToTimeline } = quickActionsObject
  try {
    if (addCriticalCareToTimeline) {
      yield put(addCriticalCareItem())
      yield put(resetState())
    }
  } catch (e) {
    yield put(throwPcrException(`saveCriticalCareQuickActionTimeLineRow() error: ${e}`))
  }
}

export function* saveCriticalCareQuickActionTimeLineRowSaga() {
  yield takeLatest(
    [CriticalCareConstants.SET_ADD_TO_TIMELINE],
    performWithMutexHOG,
    saveCriticalCareQuickActionTimeLineRow
  )
}
